module.exports = __webpack_public_path__ + "lc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lc.svg
// module id = 657
// module chunks = 0